import type { DocumentType } from '@/features/preinvest/_shared/types'
import type { SparkyAttachment } from './types'

export const NOT_FILEABLE_TITLE = 'Dit bestandstype kan niet in het dossier'

/** Content types the dossier cannot hold (see the save endpoint's allow-list). */
export function isFileable(attachment: SparkyAttachment): boolean {
  return attachment.input_kind !== 'image' && attachment.content_type !== 'text/csv'
}

/** pdf/pptx called "deck" or "pitch" is filed as a pitch deck, anything else as "Overig". */
export function defaultDocType(attachment: SparkyAttachment): DocumentType {
  const name = attachment.filename.toLowerCase()
  const deckLike = /deck|pitch/.test(name) && (name.endsWith('.pdf') || name.endsWith('.pptx'))
  return deckLike ? 'pitch_deck' : 'other'
}
